<template>
    <div v-if="!loadingPage">
        <div v-if="isAdminIdentityVerified" class="pb-2 pb-md-1 prevent-select">
            <b-card no-body class="py-50 px-2 mb-1">
                <b-row class="align-items-center">
                    <b-col md="6">
                        <b-row>
                            <b-col md="12" cols="12" class="py-50 py-md-1">
                                <div>
                                    <b-form-input v-model="orderForm.description" autocomplete="off" id="description"
                                        dir="rtl" class="text-center" placeholder="توضیحات سفارش" />
                                </div>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col md="6">
                        <b-row>
                            <b-col md="6" cols="12"
                                class="d-flex align-items-center justify-content-center py-50 py-md-50">
                                <div
                                    class="d-flex align-items-center justify-content-center flex-wrap border border-secondary py-75 rounded w-100">
                                    <h5 class="mb-0 text-center px-50">
                                        {{ customer.phoneNumber ? `${customer.firstName}
                                        ${customer.lastName}` : 'مشتری مجموعه' }}
                                    </h5>
                                    <h5 v-if="customer.phoneNumber" class="mb-0 mt-25 px-50 text-center">
                                        {{ customer.phoneNumber ? customer.phoneNumber : '' }}
                                    </h5>
                                </div>
                            </b-col>
                            <b-col md="3" cols="6" class="py-50 py-md-1">
                                <div @click="showModalCustomersFind" class="pointer prevent-select">
                                    <div class="text-center mb-50">
                                        <feather-icon :class="{ 'text-muted': loading.customersFind }" icon="UserIcon"
                                            size="26" />
                                    </div>
                                    <div style="font-size: 13px;" :class="{ 'text-muted': loading.customersFind }"
                                        class="font-weight-bolder text-center">مشتری
                                    </div>
                                </div>
                            </b-col>
                            <b-col md="3" cols="6" class="py-50 py-md-1">
                                <div @click="deleteInvoice" class="pointer prevent-select">
                                    <div class="text-center mb-50">
                                        <feather-icon icon="TrashIcon" size="26" />
                                    </div>
                                    <div style="font-size: 13px;" class="font-weight-bolder text-center">حذف اطلاعات
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-card>
            <b-row class="match-height">
                <b-col xl="8" lg="8" md="12">
                    <b-row class="match-height h-100">
                        <b-col xl="3" lg="4" cols="4" class="pr-25 pr-md-1">
                            <div class="overflow-y-scroll-pre-invoice mb-1">
                                <b-card no-body @dblclick.prevent class="mb-0">
                                    <div v-for="(item, index) in categories" :key="`category${index}`"
                                        :class="{ 'bg-info-pre-invoice': category.id == item.id }"
                                        class="pointer border-bottom-pre-invoice p-1" @click="selectCategory(item)">
                                        <h5 class="mb-0" :class="{ 'text-white': category.id == item.id }">
                                            {{ item.name_Fa }}
                                        </h5>
                                    </div>
                                </b-card>
                            </div>
                        </b-col>
                        <b-col xl="9" lg="8" cols="8" class="pl-25 pl-md-1">
                            <b-card no-body class="overflow-y-scroll-pre-invoice mb-1">
                                <div class="h-100">
                                    <div v-if="category.products.length"
                                        class="d-flex flex-wrap justify-content-center py-50" @dblclick.prevent>
                                        <div v-for="(item, index) in category.products" :key="index"
                                            :class="item.isAvailable ? 'border border-primary' : 'border border-warning'"
                                            class="rounded pointer m-25 m-md-1 d-flex justify-content-center align-items-center position-relative pre-invoice-registration-bg"
                                            @click="addedToOrderList(item)">
                                            <div v-if="item.number"
                                                class="position-absolute text-white z-index-2 bg-secondary rounded-circle"
                                                style="left: 5px;top: 4px;width: 23px;height: 23px;">
                                                <div class="d-flex justify-content-center align-items-center h-100">
                                                    {{ item.number }}
                                                </div>
                                            </div>
                                            <div v-if="item.number" @click.stop="subtractProduct(item)"
                                                class="position-absolute text-white z-index-2 rounded-circle"
                                                style="left: 5px;bottom: 4px;width: 24px;height: 24px;">
                                                <div class="d-flex justify-content-center align-items-center h-100">
                                                    <feather-icon icon="MinusCircleIcon" size="24"
                                                        class="text-danger" />
                                                </div>
                                            </div>
                                            <div v-if="item.discountPercent"
                                                class="position-absolute text-white z-index-2 bg-danger rounded-bottom"
                                                style="right: 6px;top: -1px;width: 33px;height: 24px;">
                                                <div class="d-flex justify-content-center align-items-center h-100">
                                                    <div class="d-flex align-items-center">
                                                        <div>
                                                            {{ item.discountPercent }}
                                                        </div>
                                                        <div>%</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="position-absolute z-index-1 rounded pre-invoice-registration-cover-product"
                                                :class="{ 'pre-invoice-registration-cover-product-warning': !item.isAvailable }"
                                                :style="{ backgroundColor: !item.isAvailable ? '#724500b0' : item.color || '#000000ad' }">
                                            </div>
                                            <div v-if="item.image"
                                                class="position-absolute rounded pre-invoice-registration-bg-main"
                                                :class="item.isAvailable ? 'border border-primary' : 'border border-warning'">
                                                <img :src="BASE_URL_File + item.image"
                                                    class="object-fit-cover rounded w-100 h-100">
                                            </div>
                                            <div
                                                class="text-center position-relative z-index-1 text-truncate-4-line px-75">
                                                <div class="mb-0 text-white text-ellipsis-single-pre-invoice"
                                                    style="font-size: 16px;">
                                                    {{ item.name_Fa }}
                                                </div>
                                                <div class="d-flex align-items-center justify-content-center mb-0"
                                                    style="color: #dddddd;">
                                                    <div style="font-size: 16px;">
                                                        {{ item.basePrice.toLocaleString('fa-IR') }}
                                                    </div>
                                                    <div class="pb-25 pl-25">
                                                        ریال
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div @dblclick.prevent>
                                        <div v-for="(subCategories, index) in category.subCategories" class="mt-1"
                                            :key="`subCategories${index}`">
                                            <div class="mx-75 mb-25 mb-md-0 px-1 py-50 rounded border border-secondary text-center"
                                                style="font-size: 16px;">
                                                {{ subCategories.name_Fa }}
                                            </div>
                                            <div class="d-flex flex-wrap justify-content-center">
                                                <div v-for="(item, index) in subCategories.products"
                                                    :key="`products${index}`"
                                                    :class="item.isAvailable ? 'border border-primary' : 'border border-warning'"
                                                    class="rounded pointer m-25 m-md-1 d-flex justify-content-center align-items-center position-relative pre-invoice-registration-bg"
                                                    @click="addedToOrderList(item)">
                                                    <div v-if="item.number"
                                                        class="position-absolute text-white z-index-2 bg-secondary rounded-circle"
                                                        style="left: 5px;top: 4px;width: 23px;height: 23px;">
                                                        <div
                                                            class="d-flex justify-content-center align-items-center h-100">
                                                            {{ item.number }}
                                                        </div>
                                                    </div>
                                                    <div v-if="item.number" @click.stop="subtractProduct(item)"
                                                        class="position-absolute text-white z-index-2 rounded-circle"
                                                        style="left: 5px;bottom: 4px;width: 24px;height: 24px;">
                                                        <div
                                                            class="d-flex justify-content-center align-items-center h-100">
                                                            <feather-icon icon="MinusCircleIcon" size="24"
                                                                class="text-danger" />
                                                        </div>
                                                    </div>
                                                    <div v-if="item.discountPercent"
                                                        class="position-absolute text-white z-index-2 bg-danger rounded-bottom"
                                                        style="right: 6px;top: -1px;width: 33px;height: 24px;">
                                                        <div
                                                            class="d-flex justify-content-center align-items-center h-100">
                                                            <div class="d-flex align-items-center">
                                                                <div>
                                                                    {{ item.discountPercent }}
                                                                </div>
                                                                <div>%</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="position-absolute z-index-1 rounded pre-invoice-registration-cover-product"
                                                        :class="{ 'pre-invoice-registration-cover-product-warning': !item.isAvailable }"
                                                        :style="{ backgroundColor: !item.isAvailable ? '#724500b0' : item.color || '#000000ad' }">
                                                    </div>
                                                    <div v-if="item.image"
                                                        class="position-absolute rounded pre-invoice-registration-bg-main"
                                                        :class="item.isAvailable ? 'border border-primary' : 'border border-warning'">
                                                        <img :src="BASE_URL_File + item.image"
                                                            class="object-fit-cover rounded w-100 h-100">
                                                    </div>
                                                    <div
                                                        class="text-center position-relative z-index-1 text-truncate-4-line px-75">
                                                        <div class="mb-0 text-white text-ellipsis-single-pre-invoice"
                                                            style="font-size: 16px;">
                                                            {{ item.name_Fa }}
                                                        </div>
                                                        <div class="d-flex align-items-center justify-content-center mb-0"
                                                            style="color: #dddddd;">
                                                            <div style="font-size: 16px;">
                                                                {{ item.basePrice.toLocaleString('fa-IR') }}
                                                            </div>
                                                            <div class="pb-25 pl-25">
                                                                ریال
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-card>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col xl="4" lg="4" md="12">
                    <b-card class="mb-1">
                        <div>
                            <b-form-group label="نوع سفارش">
                                <v-select v-model="orderForm.type" :searchable="false" dir="rtl"
                                    :options="orderTypeItems" :reduce="(value) => value.id" label="name"
                                    id="orderTypeItemsId" class="bg-white" style="border-radius: 6px;"
                                    :clearable="false">
                                </v-select>
                            </b-form-group>
                        </div>
                        <hr class="border-secondary mb-25 mt-2">
                        <div class="px-1 orders-container-pre-invoice">
                            <div v-if="ordersList.length">
                                <div v-for="(item, index) in ordersList" :key="`order${index}`"
                                    class="py-75 d-flex align-items-center"
                                    :class="{ 'border-bottom': index != ordersList.length - 1 || index == 0 }">
                                    <div class="w-100">
                                        <div class="d-flex justify-content-between mb-75">
                                            <h5 class="mb-0">
                                                {{ item.name_Fa }}
                                            </h5>
                                            <div v-if="item.discountPercent" class="d-flex align-items-center">
                                                <h5 class="font-weight-bolder text-danger mb-0">
                                                    {{ item.discountPercent }}
                                                </h5>
                                                <div class="text-muted ml-25">%</div>
                                            </div>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div class="d-flex justify-content-between align-items-center"
                                                @dblclick.prevent style="width: 80px;">
                                                <feather-icon @click="addProduct(item)" icon="PlusCircleIcon"
                                                    class="pointer text-success" size="18" />
                                                <span class="font-weight-bolder">{{ item.number }}</span>
                                                <feather-icon @click="subtractProduct(item)" icon="MinusCircleIcon"
                                                    class="pointer text-danger" size="18" />
                                            </div>
                                            <div class="d-flex align-items-center">
                                                <h5 v-if="item.discountPercent"
                                                    class="mr-75 mb-0 text-muted font-weight-bolder">
                                                    {{ item.basePrice.toLocaleString('fa-IR') }}
                                                </h5>
                                                <div class="d-flex align-items-center">
                                                    <h5 class="mb-0 font-weight-bolder">
                                                        {{ item.finalPrice.toLocaleString('fa-IR') }}
                                                    </h5>
                                                    <h6 class="pb-25 ml-25 mb-0 text-muted">ریال</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <h5 v-else class="d-flex align-items-center justify-content-center h-100 mb-0 py-5">
                                محصولی به سفارش اضافه نشده است!
                            </h5>
                        </div>
                        <hr class="border-secondary mt-25">
                        <b-row class="mt-1">
                            <b-col md="12" class="mb-50">
                                <div class="d-flex align-items-center justify-content-between">
                                    <span> تعداد </span>
                                    <span class="line-between-two-elements-invoice-pre-invoice mx-1"></span>
                                    <div class="d-flex align-items-center">
                                        <h5 class="mb-0 mr-25 font-weight-bolder">{{ orderDetails.numberProducts }}
                                        </h5>
                                        <span v-if="orderDetails.numberProducts" class="text-muted">عدد</span>
                                    </div>
                                </div>
                            </b-col>
                            <b-col md="12" class="mb-50">
                                <div class="d-flex align-items-center justify-content-between">
                                    <span> جمع سفارش </span>
                                    <span class="line-between-two-elements-invoice-pre-invoice mx-1"></span>
                                    <div class="d-flex align-items-center">
                                        <h5 class="mb-0 mr-25 font-weight-bolder">
                                            {{ Math.round(orderDetails.orderAmount).toLocaleString('fa-IR') }}
                                        </h5>
                                        <span v-if="orderDetails.orderAmount" class="text-muted">ریال</span>
                                    </div>
                                </div>
                            </b-col>
                            <b-col md="12" class="mb-50">
                                <div class="d-flex align-items-center justify-content-between">
                                    <span> مالیات </span>
                                    <span class="line-between-two-elements-invoice-pre-invoice mx-1"></span>
                                    <div class="d-flex align-items-center">
                                        <h5 class="mb-0 mr-25 font-weight-bolder">
                                            {{ Math.round((calculatingTaxAuto ? (orderDetails.orderAmount *
                                                0.10) : 0)).toLocaleString('fa-IR') }}
                                        </h5>
                                        <span v-if="calculatingTaxAuto && orderDetails.orderAmount * 0.10 != 0"
                                            class="text-muted">ریال</span>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                        <div class="d-flex justify-content-center align-items-center mt-50">
                            <div class="d-flex align-items-center mb-2 mx-1">
                                <span> مبلغ قابل پرداخت : </span>
                                <h3 class="text-success mb-0 mx-25">
                                    {{ calculatingTaxAuto ? (orderDetails.amountPayable +
                                        (orderDetails.orderAmount * 0.10)).toLocaleString('fa-IR') :
                                        orderDetails.amountPayable.toLocaleString('fa-IR') }}
                                </h3>
                                <span v-if="calculatingTaxAuto ? (orderDetails.amountPayable +
                                    (orderDetails.orderAmount * 0.10)) :
                                    orderDetails.amountPayable" class="text-muted font-weight-bold">ریال</span>
                            </div>
                        </div>
                        <b-button type="submit" variant="primary" @click="preOrdetHandle"
                            :disabled="loading.preInvoiceCreate"
                            class="w-100 d-flex align-items-center justify-content-center">
                            <b-spinner v-if="loading.preInvoiceCreate" class="mr-50" variant="white" small></b-spinner>
                            <span>{{ orderDailyNumber ? 'ویرایش' : 'ثبت' }} پیش‌سفارش</span>
                        </b-button>
                    </b-card>
                </b-col>
            </b-row>
        </div>

        <b-card v-if="!isAdminIdentityVerified">
            <div class="d-flex align-items-center justify-content-center flex-wrap text-danger text-center">
                <span>برای دسترسی به این قسمت، لطفا</span>
                <router-link class="mx-25" to="/identity-management">هویت</router-link>
                <span>خود را تایید کنید.</span>
            </div>
        </b-card>


        <!------------------------------- modal customers find ------------------------------->
        <b-modal id="customers-find" title="افزودن مشتری" centered :hide-footer="true" title-class="font-weight-bolder"
            size="sm">
            <div class="p-1">
                <validation-observer ref="customersFindValidation">
                    <b-form @submit.prevent>
                        <b-form-group label="نام یا شماره اشتراک" label-for="searchCustomer" class="text-center">
                            <v-select dir="rtl" v-model="searchCustomer" :options="customerList" :filterable="false"
                                id="searchCustomer" @search="handleSearchCustomer" :loading="loadingCustomer"
                                :get-option-label="(option) => option.number + ' - ' + option.firstName + ' ' + option.lastName">
                                <template #option="{ number, firstName, lastName, phoneNumber }">
                                    <div class="d-flex align-items-center">
                                        <div>{{ number }}</div>
                                        <span class="mx-50">-</span>
                                        <div class="mr-50">{{ firstName }}</div>
                                        <div>{{ lastName }}</div>
                                        <span class="mx-50">/</span>
                                        <div>{{ phoneNumber }}</div>
                                    </div>
                                </template>
                                <template #no-options>
                                    موردی وجود ندارد
                                </template>
                                <template #spinner="{ loading }">
                                    <div v-if="loadingCustomer" style="border-right-color: #7367f0" class="vs__spinner">
                                    </div>
                                </template>
                            </v-select>
                        </b-form-group>
                        <b-form-group label="شماره همراه" label-for="phone" class="text-center mt-3">
                            <validation-provider #default="{ errors }" name="شماره همراه" rules="phoneNumber|required">
                                <cleave :disabled="!!searchCustomer" id="phone" dir="ltr" v-model="customerPhoneNumber"
                                    inputmode="numeric" autocomplete="off"
                                    class="form-control text-center font-weight-bolder"
                                    :class="{ 'border-danger': errors.length > 0 }" :options="options.phone" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                        <b-button type="submit" variant="info" @click="customersFind" :disabled="loading.customersFind"
                            class="w-100 mt-2 d-flex align-items-center justify-content-center">
                            <b-spinner v-if="loading.customersFind" class="mr-50" variant="white" small></b-spinner>
                            <span>افزودن</span>
                        </b-button>
                    </b-form>
                </validation-observer>
            </div>
        </b-modal>

        <!------------------------------- modal create customer ------------------------------->
        <b-modal id="create-customer" title="ایجاد مشتری" centered :hide-footer="true" title-class="font-weight-bolder"
            size="sm">
            <div class="p-1">
                <validation-observer ref="createCustomerValidation">
                    <b-form @submit.prevent>

                        <!-- firstName -->
                        <b-form-group label="نام" label-for="firstNameId" class="text-center">
                            <validation-provider #default="{ errors }" name="نام" rules="required">
                                <b-form-input autocomplete="off" dir="rtl" id="firstNameId"
                                    v-model="customerForm.firstName" name="firstName"
                                    class="text-center font-weight-bolder user-select-none"
                                    :state="errors.length > 0 ? false : null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>

                        <!-- lastName -->
                        <b-form-group label="نام خانوادگی" label-for="lastNameId" class="text-center">
                            <validation-provider #default="{ errors }" name="نام خانوادگی" rules="required">
                                <b-form-input autocomplete="off" dir="rtl" id="lastNameId"
                                    v-model="customerForm.lastName" name="lastName"
                                    class="text-center font-weight-bolder user-select-none"
                                    :state="errors.length > 0 ? false : null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>

                        <!-- phone number -->
                        <b-form-group label="شماره همراه" label-for="phoneNumberId" class="text-center">
                            <validation-provider #default="{ errors }" name="شماره همراه" rules="phoneNumber|required">
                                <b-form-input autocomplete="off" dir="ltr" id="phoneNumberId" inputmode="numeric"
                                    v-model="customerForm.phoneNumber" name="phoneNumber"
                                    :state="errors.length > 0 ? false : null"
                                    class="text-center font-weight-bolder user-select-none" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>

                        <!-- birthDate -->
                        <div>
                            <b-form-group label="تاریخ تولد" label-for="birthDateId" class="text-center">
                                <b-form-input id="birthDateId" class="text-center main-input font-weight-bolder pointer"
                                    :value="customerForm.birthDate ? new Date(customerForm.birthDate).toLocaleDateString('fa-IR') : null"
                                    name="birthDateId" />
                            </b-form-group>
                            <date-picker v-model="customerForm.birthDate" :max="currentDate" format="YYYY-MM-DD"
                                display-format="jYYYY-jMM-jDD" custom-input="#birthDateId" />
                        </div>

                        <!-- gender -->
                        <div>
                            <div class="label mb-25 text-center">جنسیت</div>
                            <div class="d-flex align-items-center justify-content-center"
                                style="width: 100%;height: 2.714rem;">
                                <div class="d-flex align-items-center">
                                    <b-form-radio v-model="customerForm.gender" name="some-radios" :value="0"
                                        class="custom-control-primary mr-2">
                                        آقا
                                    </b-form-radio>
                                    <b-form-radio v-model="customerForm.gender" name="some-radios" :value="1"
                                        class="custom-control-primary ml-2">
                                        خانم
                                    </b-form-radio>
                                </div>
                            </div>
                        </div>

                        <b-button type="submit" variant="primary" @click="createCustomer"
                            :disabled="loading.createCustomer"
                            class="w-100 mt-2 d-flex align-items-center justify-content-center">
                            <b-spinner v-if="loading.createCustomer" class="mr-50" variant="white" small></b-spinner>
                            <span>ایجاد</span>
                        </b-button>
                    </b-form>
                </validation-observer>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Cleave from 'vue-cleave-component'
import 'cleave.js/dist/addons/cleave-phone.ir'
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required, phoneNumber } from '@validations';
import {
    BCard, BCardText, BCardBody, BButton, BRow, BCol, BForm, BFormInput, BFormGroup, BDropdown, BFormRadio, BSpinner, BDropdownItem, BAvatar, BFormTextarea, BDropdownItemButton, BInputGroupPrepend, BInputGroup
} from 'bootstrap-vue';
import { storeService } from '@core/services';
import vSelect from 'vue-select';
import { accessHandling } from '@core/mixins/accessHandling';

export default {
    components: {
        Cleave,
        ValidationProvider,
        ValidationObserver,
        BInputGroupPrepend,
        BInputGroup,
        BCard,
        BCardText,
        BButton,
        BCardBody,
        BFormGroup,
        BFormRadio,
        BRow,
        BFormTextarea,
        BCol,
        BSpinner,
        BForm,
        BFormInput,
        BDropdownItem,
        BDropdown,
        BDropdownItemButton,
        BAvatar,
        vSelect
    },
    mixins: [accessHandling],
    data() {
        return {
            required,
            phoneNumber,
            options: {
                number: {
                    numeral: true,
                    numeralThousandsGroupStyle: 'thousand',
                },
                phone: {
                    phone: true,
                    phoneRegionCode: 'IR',
                    delimiter: '-',
                }
            },
            currentDate: '',
            loadingPage: false,
            loading: {
                preInvoiceCreate: false,
                customersFind: false,
                createCustomer: false,
            },
            BASE_URL_File: process.env.VUE_APP_BASE_URL_File,
            isAdminIdentityVerified: false,
            storeId: null,
            categories: [],
            category: {
                products: []
            },
            orderTypeItems: [
                { name: 'داخل سالن', id: 0 },
                { name: 'بیرون بر', id: 1 },
            ],
            ordersList: [],
            orderDetails: {
                numberProducts: 0,
                totalAmount: 0,
                orderAmount: 0,
                amountPayable: 0
            },
            orderForm: {
                customerNumber: null,
                items: [],
                tableId: null,
                description: null,
                type: 0,
            },
            calculatingTaxAuto: false,
            searchCustomer: null,
            loadingCustomer: false,
            customerList: [],
            parameters: {
                pageIndex: 1,
                pageSize: 4,
                searchTerm: null,
            },
            customerPhoneNumber: null,
            customer: {
                phoneNumber: null,
                lastName: null,
                number: null,
                firstName: null,
            },
            customerForm: {
                gender: null,
                birthDate: null,
                lastName: null,
                firstName: null,
                phoneNumber: null
            },
            orderDailyNumber: null,
            orderId: null
        }
    },
    watch: {
        'searchCustomer'() {
            if (this.searchCustomer) {
                this.customerPhoneNumber = this.searchCustomer.phoneNumber
            }
        },
    },
    methods: {
        formatDate2(date) {
            return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
        },
        createCustomer() {
            this.$refs.createCustomerValidation.validate().then((success) => {
                if (success) {
                    this.loading.createCustomer = true;
                    storeService.createCustomer(this.storeId, this.customerForm).then(({ data }) => {
                        this.customer = data
                        this.customerForm.gender = null
                        this.customerForm.birthDate = null
                        this.customerForm.lastName = null
                        this.customerForm.firstName = null
                        this.customerForm.phoneNumber = null
                        this.loading.createCustomer = false;
                        this.$refs.createCustomerValidation.reset();
                        this.$bvModal.hide('create-customer')
                        this.$notif({ type: 'success', title: 'مشتری با موفقیت به پیش‌سفارش اضافه شد' });
                    })
                        .catch(() => {
                            this.$bvModal.hide('create-customer')
                            this.customerForm.gender = null
                            this.customerForm.birthDate = null
                            this.customerForm.lastName = null
                            this.customerForm.firstName = null
                            this.customerForm.phoneNumber = null
                            this.loading.createCustomer = false;
                        });
                }
            });
        },
        customersFind() {
            this.$refs.customersFindValidation.validate().then((success) => {
                if (success) {
                    if (this.searchCustomer) {
                        this.loading.customersFind = true;
                        this.customer = {
                            firstName: this.searchCustomer.firstName,
                            id: this.searchCustomer.id,
                            lastName: this.searchCustomer.lastName,
                            phoneNumber: this.searchCustomer.phoneNumber,
                            number: this.searchCustomer.number,
                        }
                        this.$bvModal.hide('customers-find')
                        this.$notif({ type: 'success', title: 'مشتری با موفقیت به پیش‌سفارش اضافه شد' });
                        this.loading.customersFind = false;
                        this.searchCustomer = null
                        this.customerPhoneNumber = null
                        this.$refs.customersFindValidation.reset();
                    }
                    else {
                        this.customerForm.gender = null
                        this.customerForm.birthDate = null
                        this.customerForm.lastName = null
                        this.customerForm.firstName = null
                        this.customerForm.phoneNumber = null
                        this.loading.customersFind = true;
                        storeService.customersFind(this.storeId, this.customerPhoneNumber).then(({ data }) => {
                            if (data.isExists) {
                                this.customer = data.customer
                                this.customerPhoneNumber = null
                                this.loading.customersFind = false
                                this.$bvModal.hide('customers-find')
                                this.$notif({ type: 'success', title: 'مشتری با موفقیت به پیش‌سفارش اضافه شد' });
                            }
                            else {
                                this.customerForm.phoneNumber = this.customerPhoneNumber
                                this.$bvModal.hide('customers-find')
                                this.$bvModal.show('create-customer')
                                this.customerPhoneNumber = null
                                this.$notif({ type: 'normal', title: 'مشتری با این شماره یافت نشد' });
                                this.loading.customersFind = false
                            }
                            this.$refs.customersFindValidation.reset();
                        })
                            .catch(() => {
                                this.$refs.customersFindValidation.reset();
                                this.loading.customersFind = false
                            });
                    }
                }
            });
        },
        showModalCustomersFind() {
            if (this.accessHandling('employee', 'customer_create')) {
                this.$bvModal.show('customers-find')
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        handleSearchCustomer(searchTerm) {
            this.loadingCustomer = true
            clearTimeout(this.debounceTimeout)
            if (!searchTerm) {
                this.customerList = []
                this.loadingCustomer = false
                return
            }
            this.debounceTimeout = setTimeout(() => {
                this.getCustomers(searchTerm)
            }, 1000)
        },
        getCustomers(searchTerm) {
            this.parameters.searchTerm = searchTerm
            storeService.getCustomers(this.storeId, this.parameters).then(({ data }) => {
                this.customerList = data.items
                this.loadingCustomer = false
            })
        },
        keyboardHandling(event) {
            if (event.keyCode === 121 || event.keyCode === 120 && !this.loading.preInvoiceCreate) {
                if (this.orderDailyNumber) {
                    this.preInvoiceEdit()
                }
                else {
                    this.preInvoiceCreate()
                }
            }
        },
        deleteInvoice() {
            this.customer.number = null
            this.customer.lastName = null
            this.customer.firstName = null
            this.customer.phoneNumber = null
            this.customerForm.gender = null
            this.customerForm.birthDate = null
            this.customerForm.lastName = null
            this.customerForm.firstName = null
            this.customerForm.phoneNumber = null
            this.orderForm.items = []
            this.orderForm.tableId = null
            this.orderForm.description = null
            this.orderForm.customerNumber = null
            this.orderDetails.numberProducts = 0
            this.orderDetails.totalAmount = 0
            this.orderDetails.orderAmount = 0
            this.orderDetails.amountPayable = 0
            this.orderForm.type = 0
            this.searchCustomer = null
            this.customerPhoneNumber = null
            this.ordersList = []
            if (this.categories.length) {
                this.categories.forEach(obj => {
                    obj.products.forEach(product => {
                        product.number = 0;
                    });
                    if (obj.subCategories.length) {
                        obj.subCategories.forEach(subCategorie => {
                            subCategorie.products.forEach(productSub => {
                                productSub.number = 0;
                            });
                        });
                    }
                });
            }
        },
        addedToOrderList(product) {
            if (product.isAvailable) {
                let productExists = this.ordersList.some(orderProduct => orderProduct.id === product.id);
                if (!productExists) {
                    this.ordersList.push(product);
                    product.number = 1
                    this.orderDetails.numberProducts += 1
                    this.orderDetails.orderAmount += product.finalPrice
                    this.orderDetails.totalAmount += product.finalPrice
                    this.orderDetails.amountPayable += product.finalPrice
                }
                else {
                    product.number += 1
                    this.orderDetails.numberProducts += 1
                    this.orderDetails.orderAmount += product.finalPrice
                    this.orderDetails.totalAmount += product.finalPrice
                    this.orderDetails.amountPayable += product.finalPrice
                }
            }
            else {
                this.$notif({ type: 'warning', title: `"${product.name_Fa}" ناموجود است` });
            }

        },
        addProduct(product) {
            product.number += 1
            this.orderDetails.numberProducts += 1
            this.orderDetails.orderAmount += product.finalPrice
            this.orderDetails.totalAmount += product.finalPrice
            this.orderDetails.amountPayable += product.finalPrice
        },
        subtractProduct(product) {
            product.number -= 1
            this.orderDetails.numberProducts -= 1
            this.orderDetails.totalAmount -= product.finalPrice
            this.orderDetails.orderAmount -= product.finalPrice
            this.orderDetails.amountPayable -= product.finalPrice
            if (product.number == 0) {
                this.ordersList = this.ordersList.filter((item) => item.id !== product.id);
            }
        },
        selectCategory(category) {
            this.category = category
        },
        getAllProducts() {
            storeService.getAllProducts(this.storeId).then(({ data }) => {
                this.categories = data.categories
                if (this.categories.length) {
                    this.categories.forEach(obj => {
                        obj.products.forEach(product => {
                            product.number = 0;
                        });
                        if (obj.subCategories.length) {
                            obj.subCategories.forEach(subCategorie => {
                                subCategorie.products.forEach(productSub => {
                                    productSub.number = 0;
                                });
                            });
                        }
                    });
                }
                this.getInfo()
            })
        },
        getCompletionStatus() {
            this.loadingPage = true;
            storeService.getCompletionStatus(this.storeId).then(({ data }) => {
                this.isAdminIdentityVerified = data.isAdminIdentityVerified;
                if (this.isAdminIdentityVerified) {
                    this.getAllProducts();
                }
                else {
                    this.loadingPage = false;
                }
            })
        },
        preOrdetHandle() {
            if (this.orderDailyNumber) {
                this.preInvoiceEdit()
            }
            else {
                this.preInvoiceCreate()
            }
        },
        preInvoiceEdit() {
            if (this.ordersList.length) {
                this.loading.preInvoiceCreate = true;
                this.orderForm.items = []
                this.ordersList.forEach(product => {
                    this.orderForm.items.push({
                        productId: product.id,
                        count: product.number
                    });
                });
                if (!this.orderForm.description) {
                    this.orderForm.description = null
                }
                if (!this.orderForm.tableId) {
                    this.orderForm.tableId = null
                }
                this.orderForm.customerNumber = this.customer.number
                storeService.ordersPreorderEdit(this.storeId, this.orderId, this.orderForm).then(({ data }) => {
                    this.loading.preInvoiceCreate = false;
                    this.deleteInvoice()
                    this.$router.push('/daily-orders')
                })
                    .catch(() => {
                        this.loading.preInvoiceCreate = false;
                    });
            }
            else {
                this.$notif({ type: 'normal', title: 'برای ویرایش پیش‌سفارش حداقل یک مورد اضافه کنید' });
            }
        },
        preInvoiceCreate() {
            if (this.ordersList.length) {
                this.loading.preInvoiceCreate = true;
                this.orderForm.items = []
                this.ordersList.forEach(product => {
                    this.orderForm.items.push({
                        productId: product.id,
                        count: product.number
                    });
                });
                if (!this.orderForm.description) {
                    this.orderForm.description = null
                }
                if (!this.orderForm.tableId) {
                    this.orderForm.tableId = null
                }
                this.orderForm.customerNumber = this.customer.number
                storeService.preInvoiceCreate(this.storeId, this.orderForm).then(({ data }) => {
                    this.loading.preInvoiceCreate = false;
                    this.deleteInvoice()
                    this.$notif({ type: 'success', title: 'پیش‌سفارش با موفقیت ثبت شد' });
                })
                    .catch(() => {
                        this.loading.preInvoiceCreate = false;
                    });
            }
            else {
                this.$notif({ type: 'normal', title: 'برای ثبت پیش‌سفارش حداقل یک مورد اضافه کنید' });
            }
        },
        getInfo() {
            storeService.getInfo(this.storeId).then(({ data }) => {
                this.calculatingTaxAuto = data.calculatingTaxAuto
                if (this.orderDailyNumber) {
                    this.ordersPreorderFind()
                }
                else {
                    this.loadingPage = false;
                }
            })
        },
        ordersPreorderFind() {
            storeService.ordersPreorderFind(this.storeId, this.orderDailyNumber).then(({ data }) => {
                let ordersList = data.items;
                ordersList.forEach(product => {
                    this.orderDetails.numberProducts += product.count;
                    this.orderDetails.orderAmount += (product.finalPrice * product.count);
                    this.orderDetails.totalAmount += (product.finalPrice * product.count);
                    this.orderDetails.amountPayable += (product.finalPrice * product.count);
                    let originalProduct = null;
                    for (let category of this.categories) {
                        originalProduct = category.products.find(p => p.id === product.productId);
                        if (originalProduct) break;

                        if (category.subCategories && category.subCategories.length) {
                            for (let subCategory of category.subCategories) {
                                originalProduct = subCategory.products.find(p => p.id === product.productId);
                                if (originalProduct) break;
                            }
                            if (originalProduct) break;
                        }
                    }
                    if (originalProduct) {
                        originalProduct.number = product.count;
                        this.ordersList.push(originalProduct);
                    }
                });
                this.orderForm.type = data.type;
                if (data.tableId) {
                    this.orderForm.tableId = data.tableId;
                }
                if (data.description) {
                    this.orderForm.description = data.description;
                }
                if (data.customer) {
                    this.customer = {
                        firstName: data.customer.firstName,
                        id: data.customer.id,
                        lastName: data.customer.lastName,
                        phoneNumber: data.customer.phoneNumber,
                        number: data.customer.number,
                    };
                }
                this.loadingPage = false;
            })
                .catch(() => {
                    this.loadingPage = false;
                });
        },
    },
    mounted() {
        window.addEventListener('keydown', this.keyboardHandling);
        this.storeId = localStorage.getItem("storeId");
        const today = new Date();
        this.currentDate = this.formatDate2(today);
        this.orderId = this.$route.query.id
        this.orderDailyNumber = this.$route.query.dailyNumber
        this.getCompletionStatus();
    },
    beforeDestroy() {
        window.removeEventListener('keydown', this.keyboardHandling);
    },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.line-between-two-elements-invoice-pre-invoice {
    flex-grow: 1;
    border-bottom: 1px dashed #9393935d;
}

.orders-container-pre-invoice {
    height: 286.8px;
    overflow-y: scroll;
}

.orders-container-pre-invoice::-webkit-scrollbar {
    width: 4px;
    border-radius: 6px;
}

.orders-container-pre-invoice::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: 6px;
}

.orders-container-pre-invoice::-webkit-scrollbar-thumb {
    background-color: #b9b9b99a;
    border-radius: 6px;
}

.orders-container-pre-invoice::-webkit-scrollbar-thumb:hover {
    background-color: #9c9c9ca6;
}

.pre-invoice-registration-cover {
    background-color: rgb(0 0 0 / 80%);
    bottom: 0;
    z-index: 1;
    right: 0;
    left: 0;
    top: 0;
}

.pre-invoice-registration-cover-product {
    bottom: 0;
    z-index: 1;
    right: 0;
    left: 0;
    top: 0;
}

.border-bottom-pre-invoice {
    border-bottom: 1px #93939336 solid;
}

.bg-info-pre-invoice {
    background-color: #576fbd;
    transition: background-color 0.1s ease-in-out;
}

.text-ellipsis-single-pre-invoice {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.overflow-y-scroll-pre-invoice {
    @media (min-width: 767px) {
        height: 613px;
        overflow-y: scroll;
    }
}

.overflow-y-scroll-pre-invoice::-webkit-scrollbar {
    width: 4px;
    border-radius: 6px;
}

.overflow-y-scroll-pre-invoice::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: 6px;
}

.overflow-y-scroll-pre-invoice::-webkit-scrollbar-thumb {
    background-color: #b9b9b99a;
    border-radius: 6px;
}

.overflow-y-scroll-pre-invoice::-webkit-scrollbar-thumb:hover {
    background-color: #9c9c9ca6;
}

.pre-invoice-registration-bg-main {
    @media (max-width: 767px) {
        width: 100px;
        height: 100px;
    }

    @media (min-width: 767px) {
        width: 150px;
        height: 110px;
    }
}

.pre-invoice-registration-bg {
    @media (max-width: 767px) {
        width: 100px;
        height: 100px;
    }

    @media (min-width: 767px) {
        width: 150px;
        height: 110px;
    }

    background-color: #000000;
}
</style>